import { render } from "./StatsSection.vue?vue&type=template&id=27e41057&ts=true"
import script from "./StatsSection.vue?vue&type=script&lang=ts"
export * from "./StatsSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__